export default __webpack_public_path__ + "static/media/17_1.5e59243e.jpg";